var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[_c('div',{staticClass:"cg-layer center-v"},[(_vm.state === 'connecting')?_c('span',[_vm._v("Connecting....")]):_vm._e(),(_vm.state === 'email-taken')?_c('span',{staticStyle:{"color":"red"}},[_vm._v("Email is already registered....")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }